// Wraps every authed route. If the auth store doesn't have a token,
// bounces to /login with the original destination encoded in the
// `from` query param so post-login we can return.

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "../lib/store";

export function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const accessToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!accessToken) {
    return (
      <Navigate
        to={`/login?from=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
